import { OAuthApi } from './api'

/**
 * OAuth Controller
 * 
 * @class
 */
export default class OAuthController{
  /**
   * Start the authentication process
   * 
   * @returns {Promise}
   */
  authenticate(){
    return OAuthApi.authenticate()
  }

  /**
   * Log the user out of the application
   * 
   * @returns {Promise}
   */
  logout(){
    return OAuthApi.logout()
  }
}
